import { render, staticRenderFns } from "./CounselingRegistrationForm.vue?vue&type=template&id=090dc6c2&scoped=true"
import script from "./CounselingRegistrationForm.vue?vue&type=script&lang=js"
export * from "./CounselingRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./CounselingRegistrationForm.vue?vue&type=style&index=0&id=090dc6c2&prod&lang=css"
import style1 from "./CounselingRegistrationForm.vue?vue&type=style&index=1&id=090dc6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dc6c2",
  null
  
)

export default component.exports